import { render } from "./HeadMobileComp.vue?vue&type=template&id=24b909d3&scoped=true"
import script from "./HeadMobileComp.vue?vue&type=script&lang=js"
export * from "./HeadMobileComp.vue?vue&type=script&lang=js"

import "./HeadMobileComp.vue?vue&type=style&index=0&id=24b909d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b909d3"]])

export default __exports__